import React from 'react';
import { Col, Well, Row, ControlLabel } from 'react-bootstrap';
import { I18N } from '../../../../constants';

const RecoveryActionInfo = ({ type, status }) => (
    <Well>
        <Row>
            <Col componentClass={ControlLabel} sm={4}>
                Recovery action type
            </Col>
            <Col sm={8}>{type ? I18N.RECOVERY_ACTIONS[type] : '-'}</Col>
        </Row>
        <Row>
            <Col componentClass={ControlLabel} sm={4}>
                Recovery action status
            </Col>
            <Col sm={8}>{status ? I18N.RECOVERY_ACTION_STATUS[status] : '-'}</Col>
        </Row>
    </Well>
);

export default RecoveryActionInfo;
